import React from 'react';

function interpolateColor(start, end, factor) {
    const r = Math.round(start[0] + (end[0] - start[0]) * factor);
    const g = Math.round(start[1] + (end[1] - start[1]) * factor);
    const b = Math.round(start[2] + (end[2] - start[2]) * factor);
    return `rgb(${r}, ${g}, ${b})`;
}

const ColorfulRectangle = ({ value, width, height, style }) => {
    const red = [255, 0, 0];
    const yellow = [255, 255, 0];
    const green = [0, 255, 0];

    let backgroundColor;
    if (value <= 0.25) {
        backgroundColor = interpolateColor(red, yellow, 0);
    } else if (value >= 0.75) {
        backgroundColor = interpolateColor(yellow, green, 1);
    } else if (value <= 0.5) {
        backgroundColor = interpolateColor(red, yellow, (value - 0.25) * 4);
    } else {
        backgroundColor = interpolateColor(yellow, green, (value - 0.5) * 4);
    }

    return (
        <div>
            <div
                style={{
                    ...style,
                    display: 'inline-block',
                    width: `${width}px`,
                    height: `${height}px`,
                    border: '1px solid black',
                    backgroundColor: '#eee',
                    position: 'relative'
                }}
            >
                <div
                    style={{
                        backgroundColor,
                        width: `${Math.max(0.03, value) * 100}%`,
                        height: '100%',
                        position: 'absolute',
                        bottom: 0
                    }}
                ></div>
            </div>
        </div>
    );
};

export default ColorfulRectangle;
